
<template>
  <!-- eslint-disable -->
  <svg :style="style" :class="classes" data-components="LogoFacebookSvg" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 14 24"><path fill="#fff" d="M12.49 13.395l.66-4.305H9.01V6.3c0-1.185.586-2.325 2.43-2.325h1.876V.285S11.606 0 9.97 0C6.566 0 4.33 2.07 4.33 5.805V9.09H.55v4.305h3.78V23.82c.765.12 1.53.18 2.325.18.795 0 1.575-.06 2.325-.18V13.395h3.51z"/></svg>
</template>

<script>
import globalMixin from 'Libs/mixins/globalMixin';

export default {
  name: 'LogoFacebookSvg',
  mixins: [globalMixin],
  props: {
    width: {
      type: [String, Number, Boolean],
      default: false
    },
    height: {
      type: [String, Number, Boolean],
      default: false
    },
    original: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    style() {
      const style = {};

      if (this.width) {
        style.width = this.width + 'px';
      }

      if (this.height) {
        style.height = this.height + 'px';
      }

      return style;
    }
  }
};
</script>
